import Treeselect from '@zanmato/vue3-treeselect';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	components: {
		Treeselect
	},

	mounted() {

	},

	data() {
		return {
			hideTreeSelectPlaceholderOnSearch: false
		};
	},

	computed: {
		selectedOptions: {
			get() {
				const modelValue = this.context._value || [];
				return this.childOptions.filter(option => {
					return modelValue.indexOf(option.uuid) > -1;
				});
			}
		},
		childOptions: {
			get() {
				const children = [];
				const options = this.context.attrs.options || [];
				options.forEach(option => {
					if(option.children) {
						children.push(...option.children);
					}
				});
				return children;
			}
		}
	},

	methods: {
		onOptionClick(option) {
			const currentValue = this.context._value || [];
			const index = currentValue.indexOf(option.uuid);
			if (index > -1) {
				const newValue = [...currentValue];
				newValue.splice(index, 1);
				if (this.context.node && typeof this.context.node.input === 'function') {
					this.context.node.input(newValue);
				}
			}
		},
		toggleShowPlaceholder(e) {
			if(e.length) {
				this.hideTreeSelectPlaceholderOnSearch = true;
			} else {
				this.hideTreeSelectPlaceholderOnSearch = false;
			}
		},
	},

	watch: {

	}
};
